import React, { useState } from 'react';
import { Phone, X, Leaf } from 'lucide-react';
import { GrassDivider } from './SectionDivider';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const Modal = ({
    isOpen,
    onClose,
    title,
    content
  }: {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    content: string;
  }) => {
    if (!isOpen) return null;
    return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-42">
        <div className="bg-brand-dark rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl border border-brand-gold/20" data-id="element-43">
          <div className="flex justify-between items-center p-6 border-b border-white/10" data-id="element-44">
            <h3 className="text-2xl font-serif font-bold text-brand-gold" data-id="element-45">
              {title}
            </h3>
            <button onClick={onClose} className="p-2 hover:bg-white/5 rounded-full transition-colors" data-id="element-46">
              <X size={24} className="text-gray-400" data-id="element-47" />
            </button>
          </div>
          <div className="p-6 overflow-y-auto flex-1" data-id="element-48">
            <div className="prose prose-invert max-w-none text-gray-300" data-id="element-49">
              {content.split('\n\n').map((paragraph, i) => <p key={i} className="mb-4" data-id="element-50">
                  {paragraph}
                </p>)}
            </div>
          </div>
          <div className="p-6 border-t border-white/10 bg-brand-black rounded-b-2xl flex justify-end" data-id="element-51">
            <button onClick={onClose} className="px-6 py-2 bg-brand-gold text-black rounded-lg font-bold hover:bg-brand-goldLight transition-colors" data-id="element-52">
              Close
            </button>
          </div>
        </div>
      </div>;
  };
  const placeholderText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.

Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.`;
  return <footer className="bg-black text-white pt-24 pb-10 relative overflow-hidden" data-id="element-53">
      <GrassDivider fill="#0A0A0A" position="top" className="z-20" data-id="element-54" />

      {/* Decorative leaves */}
      <Leaf className="absolute -left-10 bottom-20 w-48 h-48 text-brand-gold opacity-[0.02] -rotate-45 pointer-events-none" data-id="element-55" />
      <Leaf className="absolute -right-10 top-32 w-64 h-64 text-brand-gold opacity-[0.02] rotate-45 pointer-events-none" data-id="element-56" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-57">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-16 border-b border-white/10 pb-16" data-id="element-58">
          <div className="flex flex-col items-center md:items-start max-w-sm text-center md:text-left" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/hvEhkqVeZX92wrPFZpT8uE/Photoroom_20260407_091309.png" alt="EITHAN Landscaping & Junk Removal" className="h-24 mb-6 brightness-0 invert" data-id="element-60" />
            <p className="text-gray-400 mb-6" data-id="element-61">
              Licensed & Insured | Free Estimates | Serving Chattanooga TN &
              North Georgia
            </p>
            <a href="tel:4233203426" className="inline-flex items-center gap-2 text-brand-gold hover:text-brand-goldLight transition-colors text-xl font-bold" data-id="element-62">
              <Phone size={20} data-id="element-63" />
              423-320-3426
            </a>
            <a href="mailto:eithanslandscapingjunkremoval@gmail.com" className="inline-flex items-center gap-2 text-gray-400 hover:text-brand-gold transition-colors mt-3 text-sm" data-id="element-64">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-65">
                <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-66" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-67" />
              </svg>
              eithanslandscapingjunkremoval@gmail.com
            </a>
          </div>

          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-68">
            <h4 className="text-lg font-bold font-serif mb-2 text-white" data-id="element-69">
              Legal
            </h4>
            <button onClick={() => setIsPrivacyOpen(true)} className="text-gray-500 hover:text-brand-gold transition-colors" data-id="element-70">
              Privacy Policy
            </button>
            <button onClick={() => setIsTermsOpen(true)} className="text-gray-500 hover:text-brand-gold transition-colors" data-id="element-71">
              Terms of Service
            </button>
          </div>
        </div>

        <div className="text-center text-gray-600 text-sm" data-id="element-72">
          <p data-id="element-73">
            &copy; {new Date().getFullYear()} EITHAN Landscaping & Junk Removal.
            All rights reserved.
          </p>
        </div>
      </div>

      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Privacy Policy" content={placeholderText} data-id="element-74" />
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms of Service" content={placeholderText} data-id="element-75" />
    </footer>;
}